export default __webpack_public_path__ + "static/media/cauhon.525e7d24.jpeg";